var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManagementIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.85,
    height: 16.823,
    viewBox: "0 0 17.85 16.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23546",
    "data-name": "Group 23546",
    transform: "translate(-65.5 -761.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_6fwRkP.tif",
    "data-name": "6fwRkP.tif",
    transform: "translate(-230.998 616.949)",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(297 145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M22618.967-8455.375h-9.076a.68.68,0,0,1-.393-.392v-3.566a2.224,2.224,0,0,0,.039-.222,4.761,4.761,0,0,1,1.414-2.79,4.764,4.764,0,0,1,2.846-1.311c.129-.013.258-.018.393-.023h.031c.115,0,.223-.01.326-.016l-.047-.034-.018-.014a.871.871,0,0,1-.072-.054,4.032,4.032,0,0,1-1.141-4.027,4.006,4.006,0,0,1,2.9-2.97,3.971,3.971,0,0,1,.49-.108l.068-.013.168-.032h.777l.025,0,.033.006c.047.009.1.018.146.03a3.989,3.989,0,0,1,3.346,2.839,3.98,3.98,0,0,1-1.074,4.282l-.021.021c-.025.025-.045.047-.064.069.105.008.209.012.307.016h.012c.152.006.277.012.41.024a4.967,4.967,0,0,1,.66.113l-.9.9c-.059,0-.121-.006-.2-.007l-2.043,0-2.041,0h-2.045a3.714,3.714,0,0,0-3.549,2.755,4.173,4.173,0,0,0-.131.977c-.012.553-.012,1.107-.006,1.771v.716h7.9l.529,1.05Zm-1.666-14.539a3.126,3.126,0,0,0-3.129,3.1,3.121,3.121,0,0,0,3.1,3.129h.012a3.117,3.117,0,0,0,3.117-3.095A3.122,3.122,0,0,0,22617.3-8469.914Z",
    transform: "translate(-22609.5 8470.949)",
    fill: "#656565",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M297,613a.693.693,0,0,0,.389.389H297Z",
    transform: "translate(-297 -597.815)",
    fill: "#656565"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23430",
    "data-name": "Group 23430",
    transform: "translate(-200.498 425.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M283.183,349.208a.459.459,0,0,1-.013-.827.75.75,0,0,0,.313-1.092c-.176-.331-.357-.659-.561-.973a.707.707,0,0,0-1-.257.584.584,0,0,1-.9-.471.656.656,0,0,0-.683-.605q-.618,0-1.236,0a.6.6,0,0,0-.647.593.75.75,0,0,1-.924.616.668.668,0,0,0-.806.225,5.17,5.17,0,0,0-.725,1.321v.281a.759.759,0,0,0,.227.432.816.816,0,0,1,.055,1.176.646.646,0,0,0-.126.842c.174.353.382.687.588,1.02a.7.7,0,0,0,.968.285.713.713,0,0,1,.927.465c.087.371.234.506.578.533h1.434c.386-.025.518-.155.54-.531,0-.056,0-.112,0-.168a.584.584,0,0,1,.818-.49.7.7,0,0,0,.941-.233,4.653,4.653,0,0,0,.694-1.3v-.225A.759.759,0,0,0,283.183,349.208Zm-.3,1.172c-.107.186-.22.369-.318.56-.078.152-.171.181-.311.084-.061-.042-.135-.066-.195-.11a.428.428,0,0,0-.642.065.826.826,0,0,1-.3.208.652.652,0,0,0-.443.8c.037.238-.045.341-.3.323a9.079,9.079,0,0,0-.927,0c-.179.006-.247-.054-.248-.241,0-.458-.014-.453-.437-.62a2.257,2.257,0,0,1-.52-.267.474.474,0,0,0-.638,0c-.2.157-.334.137-.452-.108a9.085,9.085,0,0,0-.461-.8c-.085-.138-.094-.246.073-.311.337-.13.368-.383.287-.685a1.057,1.057,0,0,1-.027-.529.479.479,0,0,0-.328-.62c-.2-.09-.23-.2-.109-.393.176-.275.338-.56.491-.848.086-.163.184-.2.329-.087a.5.5,0,0,0,.743-.041,1.427,1.427,0,0,1,.457-.265.525.525,0,0,0,.372-.58c-.021-.412,0-.413.409-.413.272,0,.544,0,.815,0,.175,0,.275.061.245.246a.6.6,0,0,0,.492.77.118.118,0,0,1,.047.03.821.821,0,0,0,1.172.051.159.159,0,0,1,.261.043c.2.316.4.632.6.948a.359.359,0,0,1,.028.072.181.181,0,0,1-.11.186c-.112.067-.224.135-.341.194a.362.362,0,0,0-.21.462,1.415,1.415,0,0,1,.024.531.461.461,0,0,0,.261.5C283.2,349.838,283.192,349.845,282.884,350.38Z",
    transform: "translate(0 0)",
    fill: "#656565",
    stroke: "#656565",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M315.895,385.188a1.676,1.676,0,1,0,1.648,1.689A1.7,1.7,0,0,0,315.895,385.188Zm-.028,2.86a1.184,1.184,0,1,1,1.185-1.171A1.18,1.18,0,0,1,315.867,388.047Z",
    transform: "translate(-36.044 -37.946)",
    fill: "#656565",
    stroke: "#656565",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementIcon);
export default __webpack_public_path__ + "static/media/UserManagementIcon.c2d726d09af6915a2959bc822aab844e.svg";
export { ForwardRef as ReactComponent };